export default __webpack_public_path__ + "static/media/hacksheffield.eba716d7.png";